import React from "react";
import { Image, Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import dynamicPhotoPic from "@/assets/images/dynamic-photo-email.png";

import "@/assets/dynamicPhoto.less";

const AddLipShapeWorkEmailRender = ({ submitSuccessful, email, isNotVerify, handleSubmitEmail, handleGoBack }) => {
  const { t } = useTranslation(["addLipShape", "common"]);
  const [form] = Form.useForm();

  const validateMessages = {
    required: "",
    types: {
      email: t("Invalid email address"),
    },
  };

  return (
    <div className="workplace-email">
      {submitSuccessful ? (
        <div className="workplace-cont-lft workplace-cont-lft-success">
          <h3>{isNotVerify ? t("You will", { email }) : t("Verify successfully! You will", { email })}</h3>
          <p>{t("What you should expect to happen next")}</p>
          <ol>
            <li>
              <span>
                <span>1</span>
              </span>
              {t("We will process your photo into a dynamic video.")}
            </li>
            <li>
              <span>
                <span>2</span>
              </span>
              {t("After processing, we will send the video to your email.")}
            </li>
            <li>
              <span>
                <span>3</span>
              </span>
              {t("You can check the video in your email.")}
            </li>
          </ol>
          <Button onClick={handleGoBack} type="text" style={{ display: "flex", alignItems: "center", paddingLeft: 0 }}>
            <svg width="8" height="12" fill="none" style={{ marginRight: 12 }} xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 1.2L1.6 6l4.8 4.8" stroke="#1B1B1B" strokeWidth="1.602" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t("Go back")}
          </Button>
        </div>
      ) : (
        <div className="workplace-cont-lft">
          <h3>{t("Your video will be delivered via email")}</h3>
          <p>
            {t(
              "It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over."
            )}
          </p>
          <Form form={form} validateMessages={validateMessages} onFinish={handleSubmitEmail}>
            <Form.Item name="email" rules={[{ required: true, type: "email" }]}>
              <Input placeholder={t("Your Email")} />
            </Form.Item>
            <Form.Item name="firstName">
              <Input placeholder={t("First Name")} />
            </Form.Item>
            <Form.Item name="lastName">
              <Input placeholder={t("Last Name")} />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  disabled={!form.isFieldTouched("email") || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
                >
                  {t("Synthesize Video")}
                </Button>
              )}
            </Form.Item>
          </Form>
          <Button onClick={handleGoBack} type="text" style={{ display: "flex", alignItems: "center", paddingLeft: 0 }}>
            <svg width="8" height="12" fill="none" style={{ marginRight: 12 }} xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 1.2L1.6 6l4.8 4.8" stroke="#1B1B1B" strokeWidth="1.602" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t("Go back")}
          </Button>
        </div>
      )}

      <Image src={dynamicPhotoPic} preview={false} />
    </div>
  );
};

export default AddLipShapeWorkEmailRender;
